<h3 mat-dialog-title *ngIf="!userGroupChanged">Are you sure?</h3>
<h3 mat-dialog-title *ngIf="userGroupChanged">Report's criteria changed</h3>


<mat-dialog-content *ngIf="ready$ | async">
  <p *ngIf="!userGroupChanged">By Changing the Retailer selection, you'll lose the following:</p>
  <p *ngIf="userGroupChanged">The following has been removed due to Access Group change:</p>

  <div class="columns">

    <div class="column" *ngIf="summary.dimensions.length">
      <h3 class="column-label">Dimension Columns:</h3>
      <ul>
        <li *ngFor="let d of summary.dimensions" class="remove">
          {{ d.ref.display }} ({{ d.ref.retailer }})
        </li>
      </ul>
    </div>

    <div class="column" *ngIf="summary.metrics.length">
      <h3 class="column-label">Metric Columns:</h3>
      <ul>
        <li *ngFor="let d of summary.metrics" class="remove">
          {{ d.ref.display }}
        </li>
      </ul>
    </div>

    <div class="column" *ngIf="summary.metricsFilters.length">
      <h3 class="column-label">Metric Column Filters:</h3>
      <ul>
        <li *ngFor="let m of summary.metricsFilters">
          {{ m.ref.display }}
          <ul>
            <li *ngFor="let f of m.filters" class="remove">
              {{ f.field.display }} ({{ f.field.retailer }})
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="column" *ngIf="summary.filters.length">
      <h3 class="column-label">Global Filters:</h3>
      <ul>
        <li *ngFor="let f of summary.filters" class="remove">
          {{ f.field.display }} ({{ f.field.retailer }})
        </li>
      </ul>
    </div>

    <div class="column" *ngIf="summary.filterValues.length">
      <h3 class="column-label">Global Filter Values:</h3>
      <ul>
        <li *ngFor="let fs of summary.filterValues">
          {{ fs.field.display }}
          <ul>
            <li *ngFor="let val of fs.values" class="remove">
              {{ val }}
            </li>
          </ul>
        </li>
      </ul>
    </div>

  </div>

</mat-dialog-content>

<mat-dialog-actions *ngIf="!userGroupChanged">
  <button mat-stroked-button color="accent" (click)="cancel()" class="secondary-button">Cancel</button>
  <button mat-raised-button color="accent" (click)="confirm()" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="userGroupChanged">
  <button mat-raised-button color="accent" (click)="cancel()">OK</button>
</mat-dialog-actions>
